import { AclService } from "@/services/acl/acl-service";
import type { InjectionKey } from "vue";

export const ACL_SERVICE_INJECTION_KEY: InjectionKey<AclService> =
  Symbol("ACL_SERVICE");
